export default {"src":"/_next/static/media/menu2.62a8c004.svg","height":495,"width":495};